import React from "react";
import { object, array, number, string } from "prop-types";

import { Link } from "@quintype/components";
import CardImage from "../../atoms/cardimage";
import Headline from "../../atoms/headline";

import "./story-card22.m.css";

const StoryCard22 = ({ story, aspectRatio, imageType, headerType, headerLevel }) => {
  return (
    <div className="story-card story-card-8" styleName="story-card-8" id="story-card-22">
      <Link href={`/${story.slug}`}>
        <div styleName="card-wrapper">
          <CardImage showVideoIcon story={story} aspectRatio={aspectRatio} imageType={imageType} widths={[400]} />
          <div styleName="content">
            <Headline
              text={story.headline}
              headerType={headerType}
              headerLevel={headerLevel}
              story={story}
              lineClampClass="summary line-clamp line-clamp-2"
            />
          </div>
        </div>
      </Link>
    </div>
  );
};

StoryCard22.defaultProps = {
  aspectRatio: [16, 9],
  imageType: "image16x9",
  headerType: 5,
  headerLevel: 2
};

StoryCard22.propTypes = {
  story: object.isRequired,
  aspectRatio: array,
  imageType: string,
  headerType: number,
  headerLevel: number
};

export default StoryCard22;
